export const darkTheme = {
  bg:     "#0d1117",
  sidebar:"#0d1420",
  card:   "#161b22",
  border: "#1e2a3a",
  text:   "#e6edf3",
  sub:    "#7d8590",
  hover:  "#1c2128",
  input:  "#0d1117",
  pri:    "#4f8ef7",
  grn:    "#3fb950",
  red:    "#f85149",
  gold:   "#f0b429",
  cyan:   "#06b6d4",
  purple: "#8b5cf6",
};

export const lightTheme = {
  bg:     "#f4f5f9",
  sidebar:"#ffffff",
  card:   "#ffffff",
  border: "#e0e2eb",
  text:   "#1a1c2e",
  sub:    "#6b7094",
  hover:  "#f8f9fc",
  input:  "#f0f1f6",
  pri:    "#2563eb",
  grn:    "#059669",
  red:    "#dc2626",
  gold:   "#d97706",
  cyan:   "#0891b2",
  purple: "#7c3aed",
};